import "react";
import { keyframes as e, styled as t } from "styled-components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-tooltip";
//#region src/components/Tooltip/Tooltip.tsx
var a = i.Provider, o = e`
  from { opacity: 0; transform: translateY(2px); }
  to { opacity: 1; transform: translateY(0); }
`, s = e`
  from { opacity: 0; transform: translateX(-2px); }
  to { opacity: 1; transform: translateX(0); }
`, c = e`
  from { opacity: 0; transform: translateY(-2px); }
  to { opacity: 1; transform: translateY(0); }
`, l = e`
  from { opacity: 0; transform: translateX(2px); }
  to { opacity: 1; transform: translateX(0); }
`, u = t(i.Content)`
    border-radius: ${({ theme: e }) => e.radii.md};
    padding: ${({ theme: e }) => e.spacing(1)} ${({ theme: e }) => e.spacing(1.5)};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.tight};
    color: ${({ theme: e }) => e.colors.background};
    background-color: ${({ theme: e }) => e.colors.foreground};
    box-shadow: ${({ theme: e }) => e.shadows.md};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    /* Above every surface a tooltipped control can sit on, because this content
       is PORTALLED to document.body and so is stacked against them rather than
       inside them. At 50 it rendered behind every Modal (1000), the fullscreen gallery (1001/1002) and DropdownMenu (2000/2001) —
       the tooltip was mounted and hovering did nothing visible. Below the 9999
       tier (toasts, select popovers, FloatingPanel), which must stay on top. */
    z-index: 2100;

    animation-duration: 200ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    &[data-state='delayed-open'][data-side='top'] {
        animation-name: ${c};
    }
    &[data-state='delayed-open'][data-side='right'] {
        animation-name: ${l};
    }
    &[data-state='delayed-open'][data-side='bottom'] {
        animation-name: ${o};
    }
    &[data-state='delayed-open'][data-side='left'] {
        animation-name: ${s};
    }
`, d = t(i.Arrow)`
    fill: ${({ theme: e }) => e.colors.foreground};
`, f = ({ content: e, children: t, side: a = "top", align: o = "center", delayDuration: s = 300, ...c }) => /* @__PURE__ */ r(i.Root, {
	delayDuration: s,
	...c,
	children: [/* @__PURE__ */ n(i.Trigger, {
		asChild: !0,
		children: t
	}), /* @__PURE__ */ n(i.Portal, { children: /* @__PURE__ */ r(u, {
		sideOffset: 4,
		side: a,
		align: o,
		children: [e, /* @__PURE__ */ n(d, {})]
	}) })]
});
//#endregion
export { f as Tooltip, a as TooltipProvider };
